import { useState } from "react";
import { lerXmlDeNota, MAX_ARQUIVO_DA_NOTA, TIPOS_DE_ARQUIVO_DA_NOTA, type DadosDaNota } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";

type Tipo = (typeof TIPOS_DE_ARQUIVO_DA_NOTA)[number];
export type ArquivoEnviado = { fileId: string; nome: string };

function tipoDoArquivo(f: File): Tipo | null {
  const nome = f.name.toLowerCase();
  if (nome.endsWith(".xml")) return "application/xml";
  if ((TIPOS_DE_ARQUIVO_DA_NOTA as readonly string[]).includes(f.type)) return f.type as Tipo;
  if (nome.endsWith(".pdf")) return "application/pdf";
  return null;
}

/** Sobe o PDF/XML da nota (URL assinada → PUT → conferência) e, se for XML, lê os dados. */
export function useArquivoDaNota() {
  const pedir = trpc.financeiro.notas.pedirUpload.useMutation();
  const confirmar = trpc.financeiro.notas.confirmarUpload.useMutation();
  const [enviando, setEnviando] = useState(false);

  async function enviar(arquivo: File): Promise<{ enviado: ArquivoEnviado; dados: DadosDaNota | null }> {
    const contentType = tipoDoArquivo(arquivo);
    if (!contentType) throw new Error("Anexe um PDF, XML, JPG ou PNG.");
    if (arquivo.size > MAX_ARQUIVO_DA_NOTA) throw new Error("O arquivo passa de 10 MB.");
    setEnviando(true);
    try {
      const { fileId, uploadUrl, uploadHeaders } = await pedir.mutateAsync({ fileName: arquivo.name, contentType, contentLength: arquivo.size });
      const res = await fetch(uploadUrl, { method: "PUT", headers: uploadHeaders, body: arquivo });
      if (!res.ok) throw new Error("Não foi possível enviar o arquivo.");
      await confirmar.mutateAsync({ fileId });
      const dados = contentType === "application/xml" ? lerXmlDeNota(await arquivo.text()) : null;
      return { enviado: { fileId, nome: arquivo.name }, dados };
    } finally {
      setEnviando(false);
    }
  }

  return { enviar, enviando };
}
